import React from 'react';
import '../../scss/style.scss';
import es6Shim from 'es6-shim';
import ReactTooltip from 'react-tooltip';
export default function GlobalStyle(props) {
  return null
};

      import { createRoot } from 'react-dom/client';
      if (window.reactComponents === undefined) {
        window.reactComponents = {};
      }
      window.reactComponents.GlobalStyle = (function() {
        let _args = {};

        return {
          init: (Args) => {
            _args = Args;
          },
          render: () => {
            const { id, ...props } = JSON.parse(_args);
            const container = document.getElementById(id);
            const root = createRoot(container);
            root.render(<GlobalStyle {...props} />);
          }
        }
      }());
    